import { useState } from 'react';
import ModalWrapper from '../ModalWrapper';
import fluentTrending from './fluentTrending.png';
import styles from './TrackFinances.module.css';
import Button from '../../../shared/ui/button/button';
import { useIntl } from 'react-intl';

const totalSlides = 3;

export function TrackFinancesContent({ onContinue, onSkip }) {
	const intl = useIntl();
	const [currentSlide] = useState(1);

	return (
		<div className={styles.modalCard}>
			<div className={styles.iconContainer}>
				<img src={fluentTrending} alt='fluentTrending' />
			</div>

			<h1 className={styles.title}>
				{intl.formatMessage({ id: 'TrackFinancesId1' })}
			</h1>

			<p className={styles.description}>
				{intl.formatMessage({ id: 'TrackFinancesId2' })}
			</p>

			<div className={styles.pagination}>
				{Array.from({ length: totalSlides }).map((_, index) => (
					<div
						key={index}
						className={`${styles.dot} ${
							index === currentSlide ? styles.activeDot : ''
						}`}
					/>
				))}
			</div>

			<Button fullWidth onClick={onContinue}>
				{intl.formatMessage({ id: 'TrackFinancesId3' })}
			</Button>

			<Button variant='ghost' onClick={onSkip}>
				{intl.formatMessage({ id: 'TrackFinancesId4' })}
			</Button>
		</div>
	);
}

const TrackFinances = ({ isOpen, onClose, onContinue }) => {
	const handleSkip = () => {
		if (onClose) onClose();
	};

	if (!isOpen) return null;

	return (
		<ModalWrapper isOpen={isOpen} onSkip={handleSkip}>
			<TrackFinancesContent onContinue={onContinue} onSkip={handleSkip} />
		</ModalWrapper>
	);
};

export default TrackFinances;
